module.exports = __webpack_public_path__ + "static/split-ffd6b6b47d34f9e862341c2a54a84da8.png";